import { type GetApiEmployeesError, type GetApiEmployeesResponse, useGetApiEmployees } from '@sit/client-shared';
import { skipToken, type UseQueryOptions } from '@tanstack/react-query';
import { useIsStaff } from '@web/containers/Timesheets/hooks';
import { includeIntacctId, sortObjectsByNameAscUnsafe } from '@web/helpers/utils';
import { useCurrentEntity } from '@web/hooks/use-current-entity';
import { useMemo } from 'react';
import { useShowIntacctId } from '../show-intacct-id';

export function useGetEmployees(
  companyId?: string,
  options?: Omit<
    UseQueryOptions<GetApiEmployeesResponse, GetApiEmployeesError, GetApiEmployeesResponse>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) {
  const staff = useIsStaff();
  const currentCompanyId = useCurrentEntity()?.id;
  const selectedCompanyId = companyId ?? currentCompanyId;
  const result = useGetApiEmployees(
    staff && selectedCompanyId
      ? {
          queryParams: {
            companyId: selectedCompanyId,
          },
        }
      : skipToken,
    {
      ...options,
      enabled: options?.enabled !== false,
    },
  );
  const showIntacctId = useShowIntacctId();
  const emloyeesData = result.data?.employees;
  const employees = useMemo(() => {
    if (!emloyeesData) return undefined;
    return (showIntacctId ? emloyeesData.map((d) => includeIntacctId(d, { fieldName: 'employeeId' })) : [...emloyeesData]).sort(
      sortObjectsByNameAscUnsafe,
    );
  }, [emloyeesData, showIntacctId]);
  return { ...result, data: { employees } };
}
